/**
 * AdminCheckbox — square check toggle for admin multi-select lists
 * (invites bulk actions, permissions, …). Theme-driven; web cursor.
 */
import { Platform, Pressable, Text, type ViewStyle } from "react-native";

import { RADII, STROKES } from "../../../lib/brand";
import type { PaneTheme } from "../../brand/paneThemes";

export function AdminCheckbox({
  theme,
  checked,
  onPress,
  size = 18,
}: {
  theme: PaneTheme;
  checked: boolean;
  onPress: () => void;
  size?: number;
}) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="checkbox"
      accessibilityState={{ checked }}
      style={[
        {
          width: size,
          height: size,
          borderRadius: RADII.xs,
          borderWidth: STROKES.border,
          borderColor: checked ? theme.accent : theme.borderStrong,
          backgroundColor: checked ? theme.accent : "transparent",
          alignItems: "center",
          justifyContent: "center",
        },
        Platform.OS === "web" ? ({ cursor: "pointer" } as unknown as ViewStyle) : null,
      ]}
    >
      {checked ? (
        <Text style={{ fontFamily: theme.bodyBoldFont, fontSize: size * 0.55, color: theme.accentText }}>✓</Text>
      ) : null}
    </Pressable>
  );
}
